import { Flex } from "@chakra-ui/react"
import ResidentCurrentContract from "../components/residentdashboard/ResidentCurrentContract"

const ResidentDashboard = () => {
  return (
    <Flex p="40px" direction="column" w="full">
        <ResidentCurrentContract />
    </Flex>
  )
}

export default ResidentDashboard